var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0026 2.66406C2.52984 2.66406 1.33594 3.85797 1.33594 5.33073V11.3307C1.33594 12.4353 2.23137 13.3307 3.33594 13.3307H9.33594H10.0026H10.6693H12.6693C13.7738 13.3307 14.6693 12.4353 14.6693 11.3307V8.66406C14.6693 7.1913 13.4754 5.9974 12.0026 5.9974H10.6693V5.33073C10.6693 3.85797 9.47536 2.66406 8.00261 2.66406H4.0026ZM10.6693 7.33073V11.9974H12.6693C13.0375 11.9974 13.3359 11.6989 13.3359 11.3307V8.66406C13.3359 7.92768 12.739 7.33073 12.0026 7.33073H10.6693ZM9.33594 5.9974V5.33073C9.33594 4.59435 8.73899 3.9974 8.00261 3.9974H4.0026C3.26622 3.9974 2.66927 4.59435 2.66927 5.33073V11.3307C2.66927 11.6989 2.96775 11.9974 3.33594 11.9974H9.33594V6.66406V5.9974Z",
    fill: "#1EB865"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 11.3307C4.66406 10.9625 4.96254 10.6641 5.33073 10.6641H6.66406C7.03225 10.6641 7.33073 10.9625 7.33073 11.3307V13.3307H4.66406V11.3307Z",
    fill: "#1EB865"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.33594C5.63181 5.33594 5.33333 5.63441 5.33333 6.0026V6.66927H4.66667C4.29848 6.66927 4 6.96775 4 7.33594C4 7.70413 4.29848 8.0026 4.66667 8.0026H5.33333V8.66927C5.33333 9.03746 5.63181 9.33594 6 9.33594C6.36819 9.33594 6.66667 9.03746 6.66667 8.66927V8.0026H7.33333C7.70152 8.0026 8 7.70413 8 7.33594C8 6.96775 7.70152 6.66927 7.33333 6.66927L6.66667 6.66927V6.0026C6.66667 5.63441 6.36819 5.33594 6 5.33594Z",
    fill: "#1EB865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHospital);
export default __webpack_public_path__ + "static/media/green-hospital.e3dc89ecf68d463053de0095f4b9bee4.svg";
export { ForwardRef as ReactComponent };